import ContentClear from '@mui/icons-material/Clear';
import IconSearch from '@mui/icons-material/Search';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import { action, computed, makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';
import '../css/botao.css';
import NumeroProcessoUtil, { TIPO_ESTRUTURA_NUMERO_PROCESSO } from '../util/NumeroProcessoUtil';
import ReactComponent from "@/components/ReactComponent";

/** @type {Object} */
const styleNumero = {
    width: '9ch',
    textAlign: 'right !important'
};

/** @type {Object} */
const styleDigito = {
    width: '3ch'
};

/** @type {Object} */
const styleAno = {
    width: '5ch'
};

/** @type {Object} */
const styleOrgao = {
    width: '2ch'
};

/** @type {Object} */
const styleRegional = {
    width: '3ch'
};

/** @type {Object} */
const styleVara = {
    width: '5ch'
};

class NumeroProcesso extends ReactComponent {
    numero;
    digito;
    ano;
    orgao;
    regional;
    vara;

    refNumero = React.createRef();
    refDigito = React.createRef();
    refAno = React.createRef();
    refOrgao = React.createRef();
    refRegional = React.createRef();
    refVara = React.createRef();

    constructor(props) {
        super(props);

        makeObservable(this, {
            numero: observable,
            digito: observable,
            ano: observable,
            orgao: observable,
            regional: observable,
            vara: observable,
            carregarNumeroProcesso: action,
            handleNumero: action,
            handleApenasNumero: action,
            handleDigito: action,
            handleAno: action,
            handleOrgao: action,
            handleRegional: action,
            handleVara: action,
            handleClicklimpar: action,
            inputPropsStyle: computed
        });

        this.carregarNumeroProcesso();
    }

    carregarNumeroProcesso() {
        this.numero = this.observableProps.numero ? this.observableProps.numero : '';
        this.digito = this.observableProps.digito ? this.observableProps.digito : '';
        this.ano = this.observableProps.ano ? this.observableProps.ano : '';
        this.orgao = this.observableProps.orgao ? this.observableProps.orgao : '';
        this.regional = this.observableProps.regional ? this.observableProps.regional : '';
        this.vara = this.observableProps.vara ? this.observableProps.vara : '';
    }

    handleNumeroEvent = (event) => {
        let num = event.target.value;
        this.handleNumero(num);
        this.observableProps.callbackOnBlur && this.observableProps.callbackOnBlur(this.getNumeroProcesso());
        this.observableProps.callbackOnChange && this.observableProps.callbackOnChange(this.getNumeroProcesso());
    };

    handleNumero = (num) => {
        num = num.replace(/^0+/, '');

        if (num.indexOf('-') !== -1) {
            const numero = NumeroProcessoUtil.removerClasseProcessual(num);
            const match = TIPO_ESTRUTURA_NUMERO_PROCESSO.GENERICA.exec(numero);

            if (match !== null) {
                const numeroProcessoObj = NumeroProcessoUtil.getObjetoNumeroProcesso(num, false);
                this.numero = Number(numeroProcessoObj.numero);
                this.digito = numeroProcessoObj.digito;
                this.ano = numeroProcessoObj.ano;
                this.orgao = numeroProcessoObj.orgao;
                this.regional = numeroProcessoObj.regional;
                this.vara = numeroProcessoObj.vara;
            } else {
                this.handleApenasNumero(num);
            }
        } else {
            if (num.length === 20 && TIPO_ESTRUTURA_NUMERO_PROCESSO.APENAS_NUMEROS.test(num)) {
                const numeroProcessoObj = NumeroProcessoUtil.getObjetoNumeroProcesso(num, false);
                this.numero = numeroProcessoObj.numero;
                this.digito = numeroProcessoObj.digito;
                this.ano = numeroProcessoObj.ano;
                this.orgao = numeroProcessoObj.orgao;
                this.regional = numeroProcessoObj.regional;
                this.vara = numeroProcessoObj.vara;

                return;
            } else if (num.length >= 7) {
                num = num.toString().substring(0, 7);
                this.refDigito.current.focus();
            }

            this.numero = num.replace(/\D+/g, '').trim();
        }
    };

    handleApenasNumero = (num) => {
        let numeroSeparado = num.split('-');
        this.numero = numeroSeparado[0].trim().toString().substring(0, 7);

        if (numeroSeparado[1]) {
            let restoNumeroUnico = numeroSeparado[1].split('.');

            this.digito = restoNumeroUnico[0] ? restoNumeroUnico[0].toString().substring(0, 2) : '';
            this.ano = restoNumeroUnico[1] ? restoNumeroUnico[1].toString().substring(0, 4) : '';
            this.orgao = restoNumeroUnico[2] ? restoNumeroUnico[2].toString().substring(0, 1) : '';
            this.regional = restoNumeroUnico[3] ? restoNumeroUnico[3].toString().substring(0, 2) : '';
            this.vara = restoNumeroUnico[4] ? restoNumeroUnico[4].toString().substring(0, 4) : '';
        }
    };

    handleDigito = (event) => {
        let dig = event.target.value.replace(/\D+/g, '').trim();

        if (dig.length > 1) {
            dig = dig.toString().substring(0, 2);
            this.refAno.current.focus();
        }

        this.digito = dig;

        this.observableProps.callbackOnChange && this.observableProps.callbackOnChange(this.getNumeroProcesso());
    };

    handleAno = (event) => {
        let ano = event.target.value.replace(/\D+/g, '').trim();
        ano = ano.replace(/^0+/, '');
        if (ano.length > 3) {
            ano = ano.toString().substring(0, 4);
            this.refOrgao.current.focus();
        }
        this.ano = ano;

        this.observableProps.callbackOnChange && this.observableProps.callbackOnChange(this.getNumeroProcesso());
    };

    handleOrgao = (event) => {
        let orgao = event.target.value.replace(/\D+/g, '').trim();
        orgao = orgao.replace(/^0+/, '');

        if (orgao.length > 0) {
            orgao = orgao.toString().substring(0, 1);
            this.refRegional.current.focus();
        }
        this.orgao = orgao;
        this.observableProps.callbackOnChange && this.observableProps.callbackOnChange(this.getNumeroProcesso());
    };

    handleRegional = (event) => {
        let reg = event.target.value.replace(/\D+/g, '').trim();

        if (reg.length > 1) {
            reg = reg.toString().substring(0, 2);
            this.refVara.current.focus();
        }
        this.regional = reg;
        this.observableProps.callbackOnChange && this.observableProps.callbackOnChange(this.getNumeroProcesso());
    };

    handleVara = (event) => {
        let vara = event.target.value.replace(/\D+/g, '').trim();
        if (vara.length > 4) {
            vara = vara.toString().substring(0, 5);
            return;
        }
        this.vara = vara;
        this.observableProps.callbackOnChange && this.observableProps.callbackOnChange(this.getNumeroProcesso());
    };

    compararNumero(a, b) {
        this.handleNumero(a);
        let nb = new NumeroProcesso({});
        nb.handleNumero(b);
        for (let parte in a.state) {
            let cmp = this.compararParte(this.state[parte], nb.state[parte]);
            if (cmp === 0) {
                continue;
            }
            return cmp;
        }
    }

    compararParte(a, b) {
        if (a && b === undefined) {
            return 1;
        } else if (a === undefined && b) {
            return -1;
        } else {
            return this.compare(a, b);
        }
    }

    compare(a, b) {
        if (typeof a === 'number') {
            return a - b;
        }

        const ax = [];
        const bx = [];

        a.replace(/(\d+)|(\D+)/g, (_, $1, $2) => {
            ax.push([$1 || Infinity, $2 || '']);
        });
        b.replace(/(\d+)|(\D+)/g, (_, $1, $2) => {
            bx.push([$1 || Infinity, $2 || '']);
        });

        while (ax.length && bx.length) {
            const an = ax.shift();
            const bn = bx.shift();
            const nn = an[0] - bn[0] || an[1].localeCompare(bn[1]);
            if (nn) {
                return nn;
            }
        }

        return ax.length - bx.length;
    }

    getNumeroProcesso = () => {
        return {
            numero: this.numero,
            digito: this.digito,
            ano: this.ano,
            orgao: this.orgao,
            regional: this.regional,
            vara: this.vara,
            isPreenchido: () =>
                this.numero &&
                this.digito &&
                this.ano &&
                this.orgao &&
                this.regional &&
                this.vara &&
                this.vara.length === 4,
            numeroFormatado: () =>
                this.numero +
                '-' +
                this.digito +
                '.' +
                this.ano +
                '.' +
                this.orgao +
                '.' +
                this.regional +
                '.' +
                this.vara
        };
    };

    qualquerCampoPreenchido = () => {
        return this.numero || this.digito || this.ano || this.orgao || this.regional || this.vara;
    };

    handleClicklimpar = () => {
        this.numero = '';
        this.digito = '';
        this.ano = '';
        this.orgao = '';
        this.regional = '';
        this.vara = '';
        this.refNumero.current.focus();
        this.observableProps.clickLimpar && this.observableProps.clickLimpar();
    };

    componentDidMount() {
        /** @type {HTMLElement | null}  */
        const elementNumero = document.querySelector('#numero');

        if (elementNumero !== null) {
            elementNumero.style.textAlign = 'right';
            elementNumero.focus();
        }
    }

    pressKey = (ev) => {
        if (ev && ev.key.indexOf('Enter') > -1) {
            this.observableProps.callback && this.observableProps.callback(this.getNumeroProcesso());
        }
    };

    selecionaTexto = (event) => {
        event.target.select();
    };

    handleClickSearch = () => {
        this.observableProps.clickSearch(this.getNumeroProcesso());
    };

    handleClickIncluir = () => {
        this.observableProps.callback && this.observableProps.callback(this.getNumeroProcesso());
    };

    onBlur = () => {
        this.observableProps.callbackOnBlur && this.observableProps.callbackOnBlur(this.getNumeroProcesso());
    };

    handleKeyDown = (event, refCampoAnterior) => {
        let valor = event.target.value.replace(/\D+/g, '').trim();
        if (valor.length === 0 && (event.keyCode === 8 || event.keyCode === 46)) {
            refCampoAnterior.current.focus();
        }
    };

    get inputPropsStyle() {
        return this.observableProps.color === 'white'
            ? {
                  '&:before': {
                      borderBottom: '1px solid white'
                  },
                  '&:after': {
                      borderBottom: '1px solid white'
                  },
                  '&:hover:not(.Mui-disabled):before': {
                      borderBottom: '2px solid white'
                  },
                  '&:hover:not(.Mui-disabled):not(.Mui-focused):not(.Mui-error):before': {
                      borderBottom: '2px solid white'
                  }
              }
            : undefined;
    }

    render() {
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    minWidth: '250px',
                    alignItems: 'flex-end',
                    color: this.observableProps.color || 'black'
                }}
            >
                <Tooltip
                    disableFocusListener
                    title={this.observableProps.tooltip ? this.observableProps.tooltip : 'Número do processo'}
                    placement="top"
                >
                    <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                        {this.renderNumero()}
                        <span style={{ whiteSpace: 'pre-wrap', height: '27px' }}>{' - '}</span>
                        {this.renderDigito()}
                        <span style={{ whiteSpace: 'pre-wrap' }}>{' . '}</span>
                        {this.renderAno()}
                        <span style={{ whiteSpace: 'pre-wrap' }}>{' . '}</span>
                        {this.renderOrgao()}
                        <span style={{ whiteSpace: 'pre-wrap' }}>{' . '}</span>
                        {this.renderRegional()}
                        <span style={{ whiteSpace: 'pre-wrap' }}>{' . '}</span>
                        {this.renderVara()}
                    </div>
                </Tooltip>
                {this.renderAcoes()}
            </div>
        );
    }

    renderNumero() {
        return (
            <TextField
                id="numero"
                name="numero"
                style={styleNumero}
                value={this.numero}
                onChange={this.handleNumeroEvent}
                inputRef={this.refNumero}
                maxRows={1}
                disabled={this.observableProps.isDisabled}
                onClick={this.selecionaTexto}
                onKeyUpCapture={this.pressKey}
                onBlur={this.onBlur}
                autoComplete="off"
                slotProps={{
                    input: { sx: this.inputPropsStyle },
                    htmlInput: { style: { color: this.observableProps.color || 'black' } }
                }}
            />
        );
    }

    renderDigito() {
        return (
            <TextField
                id="digito"
                name="digito"
                style={styleDigito}
                value={this.digito}
                onChange={this.handleDigito}
                inputRef={this.refDigito}
                maxRows={1}
                disabled={this.observableProps.isDisabled}
                onKeyUpCapture={this.pressKey}
                onKeyDown={(event) => this.handleKeyDown(event, this.refNumero)}
                onClick={this.selecionaTexto}
                onBlur={this.onBlur}
                autoComplete="off"
                slotProps={{
                    input: { sx: this.inputPropsStyle },
                    htmlInput: { style: { color: this.observableProps.color || 'black' } }
                }}
            />
        );
    }

    renderAno() {
        return (
            <TextField
                id="ano"
                name="ano"
                style={styleAno}
                value={this.ano}
                onChange={this.handleAno}
                inputRef={this.refAno}
                maxRows={1}
                disabled={this.observableProps.isDisabled}
                onKeyUpCapture={this.pressKey}
                onKeyDown={(event) => this.handleKeyDown(event, this.refDigito)}
                onClick={this.selecionaTexto}
                onBlur={this.onBlur}
                autoComplete="off"
                slotProps={{
                    input: { sx: this.inputPropsStyle },
                    htmlInput: { style: { color: this.observableProps.color || 'black' } }
                }}
            />
        );
    }

    renderOrgao() {
        return (
            <TextField
                id="orgao"
                style={styleOrgao}
                value={this.orgao}
                onChange={this.handleOrgao}
                inputRef={this.refOrgao}
                maxRows={1}
                disabled={this.observableProps.isDisabled}
                onKeyUpCapture={this.pressKey}
                onKeyDown={(event) => this.handleKeyDown(event, this.refAno)}
                onClick={this.selecionaTexto}
                onBlur={this.onBlur}
                autoComplete="off"
                slotProps={{
                    input: { sx: this.inputPropsStyle },
                    htmlInput: { style: { color: this.observableProps.color || 'black' } }
                }}
            />
        );
    }

    renderRegional() {
        return (
            <TextField
                id="regional"
                style={styleRegional}
                value={this.regional}
                onChange={this.handleRegional}
                inputRef={this.refRegional}
                maxRows={1}
                disabled={this.observableProps.isDisabled}
                onKeyUpCapture={this.pressKey}
                onKeyDown={(event) => this.handleKeyDown(event, this.refOrgao)}
                onClick={this.selecionaTexto}
                onBlur={this.onBlur}
                autoComplete="off"
                slotProps={{
                    input: { sx: this.inputPropsStyle },
                    htmlInput: { style: { color: this.observableProps.color || 'black' } }
                }}
            />
        );
    }

    renderVara() {
        return (
            <TextField
                id="vara"
                style={styleVara}
                value={this.vara}
                onChange={this.handleVara}
                inputRef={this.refVara}
                maxRows={1}
                disabled={this.observableProps.isDisabled}
                onKeyUpCapture={this.pressKey}
                onKeyDown={(event) => this.handleKeyDown(event, this.refRegional)}
                onClick={this.selecionaTexto}
                onBlur={this.onBlur}
                autoComplete="off"
                slotProps={{
                    input: { sx: this.inputPropsStyle },
                    htmlInput: { style: { color: this.observableProps.color || 'black' } }
                }}
            />
        );
    }

    renderAcoes() {
        return (
            <>
                <Tooltip
                    title={'Limpar'}
                    placement="top"
                >
                    <Box style={{ marginLeft: '4px', height: '26px' }}>
                        <ContentClear
                            onClick={this.handleClicklimpar}
                            style={{ cursor: 'pointer', width: '20px', height: '20px' }}
                        />
                    </Box>
                </Tooltip>
                {this.observableProps.clickSearch && (
                    <Tooltip
                        title={'Pesquisar'}
                        placement="top"
                    >
                        <Box style={{ marginLeft: '4px', height: '26px' }}>
                            <IconSearch
                                onClick={this.handleClickSearch}
                                style={{ cursor: 'pointer', width: '20px', height: '20px' }}
                            />
                        </Box>
                    </Tooltip>
                )}
            </>
        );
    }
}

NumeroProcesso.propTypes = {
    numero: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    digito: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    ano: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    orgao: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    regional: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    vara: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    callbackOnBlur: PropTypes.func,
    callbackOnChange: PropTypes.func,
    clickLimpar: PropTypes.func,
    clickSearch: PropTypes.func,
    callback: PropTypes.func,
    color: PropTypes.string,
    tooltip: PropTypes.string,
    isDisabled: PropTypes.bool
};

export default observer(NumeroProcesso);
